import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "19.31",
  fill: "#e5f3ff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: "19.833",
  cy: "20.129",
  rx: "16.385",
  ry: "15.992",
  fill: "#cee8ff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.995 14.067h21.811v15.035H8.995z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.936 30.796c0-.936.758-1.694 1.694-1.694h20.54c.936 0 1.694.758 1.694 1.694h0H7.936h0zm3.572-19.939a1.61 1.61 0 0 1 1.607-1.607h13.929a1.61 1.61 0 0 1 1.607 1.607h0-17.143 0z",
  fill: "#bcccda"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.258 10.857A2.86 2.86 0 0 1 18.115 8h3.75a2.86 2.86 0 0 1 2.857 2.857h0-9.464 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.936 30.5h23.929v.357H7.936V30.5z",
  fill: "#a0b9cd"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#e2e6ea"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.936 19.648v-2.952l-2.411-.482-2.103.482-.308 2.873c.041.304.135.596.272.859l.053.098c.166.289.386.54.644.739a2.37 2.37 0 0 0 2.871 0c.258-.199.478-.45.644-.739l.053-.098c.137-.264.231-.556.271-.865l.013.084zm8.72-.166c.004.035-.274-2.872-.274-2.872l-1.905-.376-2.194.376v2.926h0l.007-.055c.161 1.291 1.138 2.242 2.243 2.207 1.061-.033 1.969-.967 2.122-2.207h0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.283 19.536V16.61h0-4.346v2.956c.177 1.225 1.107 2.129 2.182 2.123s1.999-.924 2.164-2.152z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.297 16.615h4.099l-.556-5.725h-3.543v5.725zm-4.347 0V10.89h-3.543l-.556 5.725h4.099z",
  fill: "#e1e8fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.786 19.503c.001.009.007-2.856.007-2.856l-.003-.076h-4.461l.278 3.04c.2 1.287 1.145 2.199 2.188 2.136.999-.061 1.843-1.002 1.992-2.243zm-17.246.006l.289-2.938H9.011l-.004.076v2.374h.003l-.003.127c.022 1.419 1.024 2.564 2.219 2.6 1.124.034 2.134-.923 2.314-2.239z",
  fill: "#e2e6ea"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.723 10.679h-3.645l-1.875.742-1.895-.742h-4.624l-2.181.643-1.589-.643h-3.663a.68.68 0 0 0-.66.511l-1.209 4.663a.68.68 0 0 0-.022.171v2.143h.003l-.003.115c0 1.295 1.05 2.345 2.345 2.345 1.186 0 2.166-.881 2.322-2.024.156 1.143 4.489 1.143 4.645 0 .156 1.143 4.488 1.143 4.645 0 .156 1.143 4.488 1.143 4.645 0 .156 1.143 1.136 2.024 2.322 2.024s2.166-.881 2.322-2.024l.008.05v-2.628a.68.68 0 0 0-.022-.171l-1.209-4.663a.68.68 0 0 0-.66-.511h0z",
  fill: "#0b599e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.684 18.679v-2.724l-2.329-.445-2.032.445-.297 2.652a2.36 2.36 0 0 0 .263.793l.052.09a2.36 2.36 0 0 0 .622.682c.811.596 1.963.596 2.774 0 .25-.184.462-.415.622-.682l.052-.09c.132-.243.223-.513.262-.799l.013.078zm9.263-.082c.005.033-.292-2.646-.292-2.646l-2.027-.346-2.334.346v2.697h0l.008-.05a2.37 2.37 0 0 0 2.386 2.034c1.129-.031 2.095-.892 2.258-2.034h0z",
  fill: "#e2b702"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.294 18.647V15.95h0-4.624v2.724a2.35 2.35 0 0 0 2.322 1.956 2.35 2.35 0 0 0 2.303-1.984z",
  fill: "#105592"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.309 15.955h4.361l-.591-5.276h-3.77v5.276zm-4.625 0v-5.276h-3.77l-.591 5.276h4.361z",
  fill: "#ffce00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.606 18.6c.001.008.008-2.578.008-2.578a.53.53 0 0 0-.004-.069h-4.941l.307 2.744a2.37 2.37 0 0 0 2.423 1.928c1.107-.055 2.042-.904 2.206-2.025zm-18.58.006l.297-2.652h-4.96l-.004.069v2.143h.003l-.003.115c.022 1.281 1.054 2.315 2.284 2.347 1.157.03 2.196-.833 2.382-2.021z",
  fill: "#105592"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7f9ff",
  d: "M17.466 29.102h5.082v1.694h-5.082z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.401 25.357a2 2 0 0 1 2-2h1.179a2 2 0 0 1 2 2v5.5h-5.179v-5.5z",
  fill: "#786619"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ffce00"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.889 25.775a2 2 0 0 1 2-2h.118v6.564h-2.118v-4.564z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.125 25.775a2 2 0 0 0-2-2h-.117v6.564h2.117v-4.564z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#64540f"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "18.919",
  cy: "27.375",
  r: ".268"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "21.061",
  cy: "27.375",
  r: ".268"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.901 24.607c0-.099.08-.179.179-.179h0c.099 0 .179.08.179.179v5c0 .099-.08.179-.179.179h0c-.099 0-.179-.08-.179-.179v-5z",
  fill: "#786619"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.678 30.584c0-.234.19-.424.423-.424h3.812c.234 0 .424.19.424.424h0-4.659 0z",
  fill: "#bcccda"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#a1b5c7",
  d: "M17.401 30.5h5.179v.357h-5.179z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "29.901",
  y: "22.643",
  width: ".357",
  height: "5.357",
  rx: ".179",
  fill: "#d8e1e9"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#a1b5c7"
}, /*#__PURE__*/React.createElement("rect", {
  x: "31.151",
  y: "29.607",
  width: ".357",
  height: "7.679",
  rx: ".179",
  transform: "rotate(90 31.151 29.607)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "16.686",
  y: "29.607",
  width: ".357",
  height: "7.679",
  rx: ".179",
  transform: "rotate(90 16.686 29.607)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#e8eff5"
}, /*#__PURE__*/React.createElement("rect", {
  x: "22.758",
  y: "9.607",
  width: ".357",
  height: "5.714",
  rx: ".179",
  transform: "rotate(90 22.758 9.607)"
}), /*#__PURE__*/React.createElement("rect", {
  x: "22.043",
  y: "8.893",
  width: ".357",
  height: "4.286",
  rx: ".179",
  transform: "rotate(90 22.043 8.893)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.365 23.821a1 1 0 0 1 1-1h1.929a1 1 0 0 1 1 1v2.571h-3.929v-2.571z",
  fill: "#1690ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.346 26.392l2.946-2.678v1.25l-1.518 1.428h-1.429zm2.769-3.571l-3.75 3.393v-1.518l2.143-1.875h1.607z",
  fill: "#339eff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "24.008",
  y: "26.348",
  width: "4.659",
  height: ".424",
  rx: ".212",
  fill: "#bcccda"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.508 23.821a1 1 0 0 1 1-1h1.928a1 1 0 0 1 1 1v2.572h-3.928v-2.572z",
  fill: "#1690ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.489 26.392l2.946-2.679v1.25l-1.518 1.429h-1.428zm2.769-3.571l-3.75 3.393v-1.518l2.143-1.875h1.607z",
  fill: "#339eff"
}), /*#__PURE__*/React.createElement("rect", {
  x: "11.151",
  y: "26.348",
  width: "4.659",
  height: ".424",
  rx: ".212",
  fill: "#bcccda"
})), 'SellerStore', {
  viewBox: '0 0 40 40'
});